import { render, staticRenderFns } from "./relation.vue?vue&type=template&id=25092a3d&"
import script from "./relation.vue?vue&type=script&lang=js&"
export * from "./relation.vue?vue&type=script&lang=js&"
import style0 from "./relation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports